import { render, staticRenderFns } from "./HandleRole.vue?vue&type=template&id=48546564"
import script from "./HandleRole.vue?vue&type=script&lang=js"
export * from "./HandleRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports